// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"26":"c01a142a","50":"31d6cfe0","542":"861a8aaf","834":"643b7a7d"}[chunkId] + ".chunk.css";
};